import { defaultTo } from 'lodash';
import {
  HospitalScheduleTemplateModel,
  IHospitalScheduleTemplateModel,
  schedule,
} from '@common/models';
import { StringUtility } from '@common/utils';
import { IModel } from '../Model';

//We don't load these from api's, only post them, so I strongly implemented it the way we want hook forms to bind to it.
export interface IHospitalScheduleTemplateRequest extends IModel {
  hospitalScheduleTemplateId: number;
  hospitalId: number;
  name: string | undefined;
  isDefault: boolean;
  isActive: boolean;
  color: string | undefined;
  hospitalSchedulePreferences: schedule.EntitySchedulePreference[] | undefined;
  rowVersion: string;
}

export class HospitalScheduleTemplateRequest
  implements IHospitalScheduleTemplateRequest, IModel
{
  hospitalScheduleTemplateId: number;
  hospitalId: number;
  name: string | undefined;
  isDefault: boolean;
  isActive: boolean;
  color: string | undefined;
  rowVersion: string;
  hospitalSchedulePreferences: schedule.EntitySchedulePreference[];
  constructor(
    init?:
      | Partial<IHospitalScheduleTemplateRequest>
      | Partial<IHospitalScheduleTemplateModel>
      | Partial<HospitalScheduleTemplateModel>,
  ) {
    //can be instantiated from any of the types on init
    this.hospitalScheduleTemplateId = defaultTo(
      init?.hospitalScheduleTemplateId,
      0,
    );
    this.hospitalId = defaultTo(init?.hospitalId, 0);
    this.name = StringUtility.SanitizeString(init?.name);
    this.color = StringUtility.SanitizeString(init?.color ?? '#2596be');
    this.isActive = defaultTo(init?.isActive, false);
    this.isDefault = defaultTo(init?.isDefault, false);
    this.hospitalSchedulePreferences =
      init && init.hospitalSchedulePreferences
        ? init.hospitalSchedulePreferences.map(
            (p) => new schedule.EntitySchedulePreference(p),
          )
        : [];
    this.rowVersion = defaultTo(init?.rowVersion, '');
  }

  static fromTemplateModel(template: HospitalScheduleTemplateModel) {
    return new HospitalScheduleTemplateRequest(template);
  }
}
